import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import TopContactBar from './TopContactBar';
import NavigationHeader from './NavigationHeader';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import TestimonialsSection from './TestimonialsSection';
import TechnologiesSection from './TechnologiesSection';
import FAQSection from './FAQSection';
import ContactSection from './ContactSection';
import MapSection from '../shared/MapSection';
import GMBFeedSection from '../shared/GMBFeedSection';
import TagsSection from '../shared/TagsSection';
import Footer from './Footer';

const TemplateContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#ffffff'
}));

const Template2 = ({
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    topContactInfo,
    businessInfo,
    navigation,
    aboutUs,
    services,
    testimonials,
    technologies,
    faq,
    contactInfo,
    footer,
    location,
    gmbFeed,
    categories
  } = templateData || {};

  const scrollToId = (id) => {
    if (!id) return;
    const el = document.getElementById(id);
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const sectionIdByMenu = {
    Home: 'home',
    Services: 'services',
    'About Us': 'about',
    Blog: 'blog',
    Contacts: 'contacts'
  };

  const handleNavigate = (label) => {
    const id = sectionIdByMenu[label] || String(label || '').toLowerCase();
    scrollToId(id);
  };

  const handleHeaderCTAClick = () => {
    const phone = contactInfo?.details?.phone;
    if (phone) {
      window.location.href = `tel:${phone.replace(/\s+/g, '')}`;
      return;
    }
    scrollToId('contacts');
  };

  const handleAboutCTAClick = () => {
    scrollToId('contacts');
  };

  const handleServiceClick = (service) => {
    const url = service?.url || service?.link;
    if (url) {
      window.open(url, '_blank');
      return;
    }
    scrollToId('contacts');
  };

  const handleContactCTAClick = () => {
    scrollToId('newsletter');
  };

  return (
    <TemplateContainer>
      <TopContactBar topContactInfo={topContactInfo} />
      <NavigationHeader
        businessInfo={businessInfo}
        navigation={navigation}
        onNavigate={handleNavigate}
        onCTAClick={handleHeaderCTAClick}
      />
      <Box id="home">
        <HeroSection businessInfo={businessInfo} />
      </Box>
      <Box id="about">
        <AboutSection aboutUs={aboutUs} onCTAClick={handleAboutCTAClick} />
      </Box>
      <Box id="services">
        <ServicesSection services={services} onServiceClick={handleServiceClick} />
      </Box>
      <TestimonialsSection testimonials={testimonials} businessInfo={businessInfo} />
      <Box id="map">
        <MapSection location={location} />
      </Box>
      <GMBFeedSection gmbFeed={gmbFeed} />
      <TagsSection
        businessInfo={businessInfo}
        categories={categories}
        contactInfo={contactInfo}
      />
      <Box id="blog">
        <TechnologiesSection technologies={technologies} />
      </Box>
      <Box id="faq">
        <FAQSection faq={faq} />
      </Box>
      <Box id="contacts">
        <ContactSection contactInfo={contactInfo} onCTAClick={handleContactCTAClick} />
      </Box>
      <Footer footer={footer} businessInfo={businessInfo} services={services} contactInfo={contactInfo} />
    </TemplateContainer>
  );
};

export default Template2;